import React from "react";

import {
  MainContent,
  ContentStyled,
  TitleStyled,
  ButtonStyled,
  ButtonText,
} from "./styles";

import LogoIcon from "../../assets/tulz-logo-old.png";
const DATA = [
  {
    title: "0",
    color: "#B72126",
  },
  {
    title: "1",
    color: "#D61F27",
  },
  {
    title: "2",
    color: "#F05224",
  },
  {
    title: "3",
    color: "#F36F20",
  },
  {
    title: "4",
    color: "#FBA822",
  },
  {
    title: "5",
    color: "#FFCA28",
  },
  {
    title: "6",
    color: "#ECDB13",
  },
  {
    title: "7",
    color: "#E8E73C",
  },
  {
    title: "8",
    color: "#C5D92D",
  },
  {
    title: "9",
    color: "#AFD136",
  },
  {
    title: "10",
    color: "#64B64D",
  },
];

const IntroPage = ({ handleRateValue, question }) => {
  const [company, setCompany] = React.useState({
    companyId: "",
    companyName: "",
  });

  return (
    <MainContent>
      <ContentStyled>
        <TitleStyled>{question}</TitleStyled>
      </ContentStyled>
      <ContentStyled style={{ display: "block" }}>
        {DATA.map((item) => (
          <ButtonStyled
            bgColor={item.color}
            onClick={() => handleRateValue(item.title)}
          >
            <ButtonText>{item.title}</ButtonText>
          </ButtonStyled>
        ))}
      </ContentStyled>

      <ContentStyled style={{ marginTop: "10%" }}>
        <img src={LogoIcon} alt="Logo Tulz" />
      </ContentStyled>
    </MainContent>
  );
};

export default IntroPage;
